import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { User } from 'src/app/models/user';
import { BhAnalyticsService } from 'src/app/services/_core/bhanalytics/bhanalytics.service';
import { NotificationsService } from 'src/app/services/_core/notifications/notifications.service';
import { UsersService } from 'src/app/services/users/users.service';
import { ManageUserEditorPage } from '../manage-user-editor/manage-user-editor.page';
import { ErrorHandlerService } from 'src/app/services/_core/error-handler/error-handler.service';

@Component({
  selector: 'app-manage-user-list',
  templateUrl: './manage-user-list.page.html',
  styleUrls: ['./manage-user-list.page.scss'],
})
export class ManageUserListPage implements OnInit {
  initUsers: User[] = [];
  users: User[] = [];
  searchTerm = '';
  isLoading = true;

  constructor(
    private usersService: UsersService,
    private notifications: NotificationsService,
    private analytics: BhAnalyticsService,
    private modalCtrl: ModalController,
    private errorHandler: ErrorHandlerService
  ) { }

  async ngOnInit() {
    await this.loadData();
  }

  async loadData() {
    try {
      this.isLoading = true;
      const res = await firstValueFrom(this.usersService.getAll(true));
      if (res && Array.isArray(res) && res.length > 0) {
        this.initUsers = res;
        this.sortUsers();
        this.users = Object.assign([], this.initUsers);
        // console.log('loadData', this.initUsers);
      }
      this.isLoading = false;
      return Promise.resolve(true);
      // this.classes = this.testClasses;
    } catch (err) {
      this.errorHandler.handleError(err, 'loadData');
      return Promise.reject();
    }
  }

  sortUsers() {
    this.initUsers.sort((a, b) => {
      const aName = a.lastName + ',' + a.firstName;
      const bName = b.lastName + ',' + b.firstName;
      if (aName.toLowerCase() < bName.toLowerCase()) return -1;
      if (aName.toLowerCase() > bName.toLowerCase()) return 1;
      return 0;
    });
  }

  async add() {
    this.analytics.clickEvent('Manage-Users > Add', '');
    const modal = await this.modalCtrl.create({
      component: ManageUserEditorPage,
      cssClass: 'wide-modal',
      componentProps: {
        editMode: 'new',
        // userId: user.id
      }
    });

    modal.onDidDismiss().then(async (data) => {
      if (data && data.data) {
        if (data.data.isSaved) {
          await this.loadData();
          this.search(this.searchTerm);
        } else if (data.data.dismiss) {
          this.modalCtrl.dismiss();
        }
      }
    });

    await modal.present();
  }



  async edit(user: User) {
    // console.log('editing', user);
    this.analytics.clickEvent('Manage-Users > Edit', user.userName);
    const modal = await this.modalCtrl.create({
      component: ManageUserEditorPage,
      cssClass: 'wide-modal',
      componentProps: {
        editMode: 'edit',
        userId: user.id
      }
    });

    modal.onDidDismiss().then(async (data) => {
      if (data && data.data) {
        if (data.data.isSaved) {
          await this.loadData();
          this.search(this.searchTerm);
        } else if (data.data.dismiss) {
          this.modalCtrl.dismiss();
        }
      }
    });

    await modal.present();
  }

  search(ev) {
    this.searchTerm = (ev.detail) ? ev.detail.value : this.searchTerm;
    const qry = this.searchTerm.toLowerCase();
    if (qry) {
      for (const u of this.initUsers) {
        u.hide = u.userName.toLowerCase().indexOf(qry) === -1 &&
          u.firstName.toLowerCase().indexOf(qry) === -1 &&
          u.lastName.toLowerCase().indexOf(qry) === -1;
      }
    } else {
      for (const u of this.users) {
        u.hide = false;
      }
    }
    // console.log('search', this.searchTerm, this.users.filter(u => !u.hide));
  }

  dismiss() {
    this.analytics.clickEvent('manage-user-list: dismiss', '');
    this.modalCtrl.dismiss();
  }


}
